import { render, staticRenderFns } from "./SettingModal.html?vue&type=template&id=5cfef51b&scoped=true&external"
import script from "./SettingModal.ts?vue&type=script&lang=ts&external"
export * from "./SettingModal.ts?vue&type=script&lang=ts&external"
import style0 from "./SettingModal.css?vue&type=style&index=0&id=5cfef51b&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfef51b",
  null
  
)

export default component.exports